

















import Vue from 'vue';
import Component from 'vue-class-component';
import { LabelInfo, labelAdminApis } from '@/api/label.api';
import { InvalidParam } from '@/api';

@Component
export default class LabelEditDialog extends Vue {
  readonly labelWidth = '6rem';
  readonly formRules = {
    name: { required: true, message: '请输入标签标识' }
  };

  dialogVisible = false;
  saveLoading = false;

  label: LabelInfo | null = null;
  errors: any = {};

  async saveLabel() {
    this.saveLoading = true;
    try {
      const result = await labelAdminApis.saveLabel(this.label);
      this.$emit('add_label', result);
      this.$notify.success({
        title: '提示',
        message: `保存标签[${this.label?.name}]成功`,
        duration: 2000
      });
      this.dialogVisible = false;
    } catch (e) {
      if (e instanceof InvalidParam) {
        this.errors = e.params;
      } else {
        this.$notify.error(e.message);
      }
    }
    this.saveLoading = false;
  }

  show(label: LabelInfo | null) {
    this.errors = {};
    if (label) {
      this.label = JSON.parse(JSON.stringify(label));
    } else {
      this.label = {} as LabelInfo;
    }
    this.dialogVisible = true;
  }
}
